import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Sobre from "@/pages/Sobre";
import Conteudos from "@/pages/Conteudos";
import Contato from "@/pages/Contato";
import Login from "@/pages/Login";
import Cadastro from "@/pages/Cadastro";

import MemberDashboard from "@/pages/membros/Dashboard";
import MemberCourse from "@/pages/membros/Course";
import MemberLesson from "@/pages/membros/Lesson";

import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminUsers from "@/pages/admin/Users";
import AdminCourses from "@/pages/admin/Courses";
import AdminCourseEdit from "@/pages/admin/CourseEdit";
import AdminTestimonials from "@/pages/admin/Testimonials";
import AdminSettings from "@/pages/admin/Settings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/conteudos" element={<Conteudos />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />

          {/* Members */}
          <Route path="/membros" element={<ProtectedRoute><MemberDashboard /></ProtectedRoute>} />
          <Route path="/membros/curso/:id" element={<ProtectedRoute><MemberCourse /></ProtectedRoute>} />
          <Route path="/membros/aula/:id" element={<ProtectedRoute><MemberLesson /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/usuarios" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/cursos" element={<ProtectedRoute adminOnly><AdminCourses /></ProtectedRoute>} />
          <Route path="/admin/cursos/novo" element={<ProtectedRoute adminOnly><AdminCourseEdit /></ProtectedRoute>} />
          <Route path="/admin/cursos/editar/:id" element={<ProtectedRoute adminOnly><AdminCourseEdit /></ProtectedRoute>} />
          <Route path="/admin/depoimentos" element={<ProtectedRoute adminOnly><AdminTestimonials /></ProtectedRoute>} />
          <Route path="/admin/configuracoes" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
